<template>
    <div class="hero">
        <div class="hero__carousel">
            <div
                id="heroCarousel"
                class="carousel slide carousel-fade"
                data-bs-ride="carousel"
                data-bs-interval="4000"
            >
                <div class="carousel-inner">
                    <div class="carousel-item active">
                        <img src="@/assets/img/home-1.png" class="d-none d-md-block w-100" />
                        <img src="@/assets/img/home-1-bg.png" class="d-md-none w-100" />
                    </div>
                    <div class="carousel-item">
                        <img src="@/assets/img/home-2.png" class="d-none d-md-block w-100" />
                        <img src="@/assets/img/home-2-bg.png" class="d-md-none w-100" />
                    </div>
                    <div class="carousel-item">
                        <img src="@/assets/img/home-3.png" class="d-none d-md-block w-100" />
                        <img src="@/assets/img/home-3-bg.png" class="d-md-none w-100" />
                    </div>
                    <div class="carousel-item">
                        <img src="@/assets/img/home-4.png" class="d-none d-md-block w-100" />
                        <img src="@/assets/img/home-4-bg.png" class="d-md-none w-100" />
                    </div>
                    <div class="carousel-item">
                        <img src="@/assets/img/home-5.png" class="d-none d-md-block w-100" />
                        <img src="@/assets/img/home-5-bg.png" class="d-md-none w-100" />
                    </div>
                    <div class="carousel-item">
                        <img src="@/assets/img/home-6.png" class="d-none d-md-block w-100" />
                        <img src="@/assets/img/home-6-bg.png" class="d-md-none w-100" />
                    </div>
                    <div class="carousel-item">
                        <img src="@/assets/img/home-7.png" class="d-none d-md-block w-100" />
                        <img src="@/assets/img/home-7-bg.png" class="d-md-none w-100" />
                    </div>
                </div>
            </div>
        </div>
        <div class="hero__overlay"></div>
        <div class="hero__content">
            <div class="container">
                <div class="hero__label animate__animated animate__fadeInDown">
                    <span class="hero__label-line"></span>
                    <span class="hero__label-text">Odontologia Estética</span>
                </div>
                <h1 class="hero__title animate__animated animate__fadeInUp">
                    Conforto e<br>
                    <em>excelência</em><br>
                    no atendimento
                </h1>
                <p class="hero__subtitle animate__animated animate__fadeInUp">
                    Transformando sorrisos com arte, ciência e cuidado personalizado
                </p>
                <div class="hero__actions animate__animated animate__fadeInUp">
                    <a class="btn btn-hero" href="#sobre">Conheça</a>
                    <a class="btn btn-hero-outline" href="https://api.whatsapp.com/send?phone=5511953189307" target="_blank">Agende sua consulta</a>
                </div>
            </div>
        </div>
        <div class="hero__scroll-indicator">
            <span class="hero__scroll-text">Scroll</span>
            <span class="hero__scroll-line"></span>
        </div>
    </div>
</template>

<script>
export default {};
</script>

<style src="./style.scss" lang="scss" scoped/>
